//Initialize Accordion
if (document.querySelector(".accordion-container")) {
	new Accordion(".accordion-container");
}

//Carousel Script
if (document.querySelector(".myCarousel")) {
	var myCarousel = document.querySelector(".myCarousel");
	document.querySelector(".myCarousel").style.display = "flex";
	const glide = new Glide(myCarousel, {
		type: "slider",
		perView: 3,
		perTouch: 1,		
		autoplay: false,
		accessibility: true,
		startAt: 0,
		rewind: false,
		classes: {
			disabledArrow: "glide__arrow--disabled",
		},
		peek: {
			before: 100,
			after: 50,
		},
	  perSwipe: "|",  
	  breakpoints: {
		500: {
			perView: 1,
			startAt: 1,
			peek: {
				before: 50,
				after: 50,
			},
		},
		900: {
			perView: 2,
			startAt: 1,
			peek: 0,
		},
		},	  
	}).mount();

	// var glide = new Glide(myCarousel, {
	// 	type: 'carousel',
	// 	perView: 4,
	// 	focusAt: 'center',
	// 	breakpoints: {
	// 	  800: {
	// 		perView: 2
	// 	  },
	// 	  480: {
	// 		perView: 1
	// 	  }
	// 	}
	//   })
	  
	//   glide.mount();
  }

//Carousel Script
if (document.querySelector(".myCarouselNews")) {
	document.querySelector(".myCarouselNews").style.display = "flex";

	var allSlides = document.querySelectorAll(".myCarouselNews");
	var allSlidesArray = Array.prototype.slice.call(allSlides);
	allSlidesArray.forEach((slide) => {
		const glide = new Glide(slide, {
			type: "slider",
			perView: 3,
			perTouch: 1,			
			autoplay: false,
			accessibility: true,			
			startAt: 0,
			rewind: false,
			classes: {
				disabledArrow: "glide__arrow--disabled",
			},
			peek: {
				before: 100,
				after: 50,
			},
			perSwipe: "|",
			breakpoints: {
				500: {
					perView: 1,
					startAt: 1,
					peek: {
						before: 50,
						after: 50,
					},
				},
				900: {
					perView: 2,
					startAt: 1,
					peek: 0,
				},
			},
		}).mount();
	});
}

$('#myCarousel-items-news li.glide__slide').on("keydown", function (e) {	
	if (e.keyCode == 13 || e.keyCode == 32) {
		let link= $(this).find('a').attr('href');		
		if(link)
		{
			if (e.ctrlKey) {
				window.open(link, "_blank");
			}		
			else{		
				window.location.href = link;
			}
		}
	}
});
$('#myCarousel-items-role li.glide__slide').on("keydown", function (e) {
	if (e.keyCode == 13 || e.keyCode == 32) {
		let link= $(this).find('a').attr('href');		
		if(link)
		{
			if (e.ctrlKey) {
				window.open(link, "_blank");
			}		
			else{		
				window.location.href = link;
			}
		}
	}
});


//Check if Header Button link is external
if (document.querySelector(".cta-btn")) {
	let currentHost = window.location.hostname;
	let ctaBtn = document.querySelector(".cta-btn");
	let ctaLink = ctaBtn.getAttribute("href").split("/");

	if (ctaLink[0] !== currentHost) {
		ctaBtn.classList.add("external-link");
	}
}

//Menu
let hamicon = document.querySelector(".hamicon");
let nav = document.querySelector(".only-mobile-menu .main-navigation");
let hamMenu = document.querySelector(".main-navigation.hamburger-menu");
const mq = window.matchMedia("(max-width: 959px)");

//Ham Menu
if (hamMenu) {
	hamMenu.style.display = "none";
}

let primaryMenu = Array.prototype.slice.call(document.querySelectorAll(".primary-menu"));

mq.onchange = (e) => {
	if (mq.matches) {
		if (nav) {
			nav.style.display = "none";
		}

		if (hamicon) {
			hamicon.style.display = "block";
		}

		if (document.querySelector(".mobile-menu-icon")) {
			document.querySelector(".mobile-menu-icon").style.display = "block";
		}
	} else {
		if (nav) {
			nav.style.display = "block";
		}

		if (hamicon) {
			hamicon.style.display = "none";
		}
		if (document.querySelector(".mobile-menu-icon")) {
			document.querySelector(".mobile-menu-icon").style.display = "none";
		}

		primaryMenu.forEach((menu) => {
			menu.style.height = "auto";
		});
		//document.querySelector('#primary-menu').style.height = "auto";
	}
};
mq.onchange();

let openMobileNav = (e) => {
	hamicon.classList.toggle("is-active");
	if (nav) {
		nav.classList.toggle("active");
	}
	document.getElementById("content").classList.toggle("filterblur");
	document.getElementById("overlay").classList.toggle("active");
	document.getElementsByTagName("BODY")[0].classList.toggle("no-scroll");	
	if (nav) {
	nav.focus();	
	}

	let menuLabel = document.querySelector(".mobile-menu-label");
	let menuParentList = primaryMenu[1];

	if (document.querySelector(".menu-with-cta").children.length == 0 || document.querySelector(".menu-with-cta .ham-menu")) {
		menuParentList = primaryMenu[0];
	}

	//|| document.querySelector('.hamicon.ham-menu').length > 0

	//let menuParentList = document.querySelector('#primary-menu');
	let menuFromTop = menuParentList.getBoundingClientRect().top;
	
	menuParentList.classList.toggle("active-submenu");

	if (menuLabel) {
		if (nav.classList.contains("active")) {
			menuLabel.innerText = "Close";
			hamicon.setAttribute("aria-label", "close the menu");
			menuParentList.style.height = "calc(100vh - " + menuFromTop + "px)";
		} else {
			menuLabel.innerText = "Menu";
			hamicon.setAttribute("aria-label", "open the menu");
		}
	}
};

if (hamicon) {
	if (document.querySelector(".menu-with-cta .ham-menu")) {
		nav = document.querySelector(".main-navigation");
	}

	//nav = document.querySelector(".main-navigation");
	hamicon.style.display = "block";
	hamicon.addEventListener("click", openMobileNav);
	hamicon.addEventListener("keydown", (e) => {
		if (e.keyCode == 13 || e.keyCode == 32) {
			openMobileNav();
		}
	});
}

//Submenu Arrow Icon
var arrowchevron = document.createElement("div");
arrowchevron.classList.add("arrow-down");
//arrowchevron.setAttribute("tabindex", -1);
//arrowchevron.setAttribute("role", "button");
//arrowchevron.setAttribute('aria-label', 'Open submenu');
//arrowchevron.innerHTML = '<span class="screen-reader-text">Technology</span>'

let parentMenu = document.querySelectorAll(".menu-item-has-children > a");
let allparentMenu = Array.prototype.slice.call(parentMenu);

allparentMenu.forEach((menu) => {
	let parentName = menu.textContent;
	menu.setAttribute("aria-haspopup", true);
	menu.appendChild(arrowchevron.cloneNode(true));

	let arrow = menu.children[0],
		submenu = menu.nextSibling.nextSibling;
	let arrowParentAtag = arrow.parentElement;
	let arrowParentLitag = arrow.parentElement.parentElement;
	arrowParentAtag.setAttribute("aria-expanded", false);
	//arrowParent.setAttribute("aria-label", "Submenu " + parentName + " open");

	if (screen.width < 960) {
		arrow.addEventListener("click", (e) => {
			// closeAllSubmenu();			
		//	arrow.classList.toggle("rotate");
			submenu.classList.toggle("open-submenu");
			e.preventDefault();

			if (submenu.classList.contains("open-submenu")) {
				closeAllSubmenu();
				//arrow.classList.toggle("rotate");
				submenu.classList.toggle("open-submenu");
				arrowParentAtag.setAttribute("aria-expanded", true);
			//	arrow.setAttribute("aria-label", "Close " + parentName + " Submenu");
			} else {
				arrowParentAtag.setAttribute("aria-expanded", false);
			//	arrow.setAttribute("aria-label", "Open " + parentName + " Submenu");
			}
		});
	 }

	// arrow.addEventListener("keydown", (e) => {
	// 	if (e.keyCode == 13 || e.keyCode == 32) {
	// 		arrow.classList.toggle("rotate");
	// 		submenu.classList.toggle("open-submenu");
	// 		e.preventDefault();

	// 		if (submenu.classList.contains("open-submenu")) {
	// 			closeAllSubmenu();
	// 			arrow.classList.toggle("rotate");
	// 			submenu.classList.toggle("open-submenu");
	// 			submenu.setAttribute("aria-expanded", true);
	// 			arrow.setAttribute("aria-label", "Close " + parentName + " Submenu");
	// 		} else {
	// 			submenu.setAttribute("aria-expanded", false);
	// 			arrow.setAttribute("aria-label", "Open " + parentName + " Submenu");
	// 		}
	// 	}
	// });
});

function closeAllSubmenu() {
	let allArrows = document.querySelectorAll(".arrow-down");
	allArrows.forEach((ele) => {
		//ele.classList.remove("rotate");
	//	ele.setAttribute("aria-label", "Open " + ele.parentElement.textContent + " Submenu");
		let subM = ele.parentElement.nextElementSibling;
		subM.classList.remove("open-submenu");
	//	subM.setAttribute("aria-expanded", false);
	});
}

////Pagination
if (document.querySelector(".navigation-pagination")) {
	let paginationList = document.querySelectorAll(".navigation-pagination ul li");

	if (paginationList[0].classList.contains("active")) {
		paginationList[0].style.position = "relative";
	}

	if (paginationList[paginationList.length - 1].classList.contains("active")) {
		paginationList[paginationList.length - 1].style.position = "relative";
	}
}

////Masonary
if (document.querySelector(".allcontainer")) {
	var elem = document.querySelector(".allcontainer");
	var msnry = new Masonry(elem, {
		// options
		itemSelector: ".item",
		columnWidth: ".grid-sizer",
		gutter: 15,
	});

	//Filters
	// const filterBtn = document.querySelectorAll('.filters button');
	// var allfilterBtn = Array.prototype.slice.call(filterBtn);
	//let allblocks = document.querySelectorAll('.item');
	let allblocks = Array.prototype.slice.call(document.querySelectorAll(".item"));
	let selectedValue;
	let selectedOption;
	let availableItems;
	let buttons = document.querySelectorAll(".filters button"); //returns a nodelist

	for (let i = 0; i < buttons.length; i++) {
		buttons[i].addEventListener("click", onClickChange);
	}

	//Click Filter
	function onClickChange() {
		selectedValue = this.value;
		//console.log(selectedValue);
		// if(selectedValue !== 'all'){
		//   allblocks = document.querySelectorAll('.item.block');
		// }
		allblocks.forEach(function (block) {
			block.classList.remove("block");

			if (selectedValue == "all") {
				block.classList.add("block");
			}

			if (block.getAttribute("data-cat") == selectedValue) {
				block.classList.add("block");
			}
		});
		msnry.layout();

		availableItems = Array.prototype.slice.call(document.querySelectorAll(".item.block"));
		document.getElementById("select").addEventListener("change", onSelectChange);
	}

	availableItems = Array.prototype.slice.call(document.querySelectorAll(".item.block"));

	document.getElementById("select").addEventListener("change", onSelectChange);

	function onSelectChange() {
		selectedOption = this.value;

		availableItems.forEach(function (item) {
			item.classList.remove("block");

			if (selectedOption == "all") {
				item.classList.add("block");
			}

			if (item.getAttribute("data-tag") == selectedOption) {
				item.classList.add("block");
			}
		});

		//Filter Click
		for (let i = 0; i < buttons.length; i++) {
			buttons[i].addEventListener("click", onClickChange);
		}

		msnry.layout();
	}

	/////Script_AJAX
	/* Ajax functions */
	$(document).ready(function () {
		//onclick
		$("#loadMore").on("click", function (e) {
			e.preventDefault();
			//init
			var that = $(this);
			var page = $(this).data("page");
			var newPage = page + 1;
			var ajaxurl = that.data("url");
			//ajax call
			$.ajax({
				url: ajaxurl,
				type: "post",
				data: {
					page: page,
					action: "ajax_script_load_more",
				},
				error: function (response) {
					console.log(response);
				},
				success: function (response) {
					//check
					if (response == 0) {
						$(".allcontainer").append('<div class="text-center no-more-post"><h4>You reached the end of the line!</h4><p>No more posts to load.</p></div>');
						$("#loadMore").hide();
					} else {
						that.data("page", newPage);
						$("#ajax-primary").append(response);

						msnry = new Masonry(elem, {
							// options
							itemSelector: ".item",
							columnWidth: ".grid-sizer",
							gutter: 15,
						});

						msnry.layout();
					}
				},
			});
		});
	});
}

//Breadcrumb Spacing
if (document.querySelector(".breadcrumb-container")) {
	document.querySelector(".content-area").style.marginTop = 0;
}

// jQuery(document).ready(function () {
// 	jQuery(".gradientimage").hover(
// 		function () {
// 			jQuery(this).find(".hoverimage").fadeIn(800);
// 		},
// 		function () {
// 			jQuery(this).find(".hoverimage").fadeOut(300);
// 		}
// 	);
// 	$(".newsCarousal-slides li, .category-listing>ul>li>a, .category-listing .card-slider>a" ).focus( function () {			
// 		jQuery(this).find(".hoverimage").fadeIn(800);
				
// 	});
// 	$(".newsCarousal-slides li, .category-listing>ul>li>a , .category-listing .card-slider>a" ).focusout( function () {	
// 		jQuery(this).find(".hoverimage").fadeOut(300);	
				
// 	});	
// 	jQuery('.gradientimage').on('touchstart', 
// 		function () {
// 			jQuery(this).find(".hoverimage").fadeIn(400);		
// 	});
// 	jQuery('.gradientimage').on('touchend', 
// 		function () {
// 			jQuery(this).find(".hoverimage").fadeOut(300);	
// 	});
// });

//focus out of menu #Accessiblity issue
$(document).on("focusout", "#menu-main-menu-1", function (e) {
	setTimeout(function () {
		var focus = $(document.activeElement);
		if (!(focus.is("#menu-main-menu-1") || $("#menu-main-menu-1").has(focus).length)) {
			//openMobileNav();
			$('.hamicon').focus();
		}
	}, 0);
});

//focus set for sub menu
$(document).on("focusout", ".sub-menu", function (e) {
	setTimeout(function () {
		var focus = $(document.activeElement);
		if (focus.is(".sub-menu") || $(".sub-menu").has(focus).length) {
		} else {
			closeAllSubmenu();
		}
	}, 0);
});

// if (screen.width > 960) {
// let arrowDown = $(".menu-main-menu-container > ul > li > a > .arrow-down");
// arrowDown.on("keypress click", function (e) {
// 	e.preventDefault();
// 	parentName = $(this).parent().text();
// 	submenu = $(this).parent().next();
// 	$(this).toggleClass("rotate");
// 	submenu.toggleClass("open-submenu");

// 	if (submenu.hasClass("open-submenu")) {
// 		closeAllSubmenu();
// 		$(this).toggleClass("rotate");
// 		submenu.toggleClass("open-submenu");
// 		submenu.attr("aria-expanded", true);
// 		arrowDown.attr("aria-label", "Close " + parentName + " Submenu");
// 	} else {
// 		submenu.attr("aria-expanded", false);
// 		arrowDown.attr("aria-label", "Open " + parentName + " Submenu");
// 	}
// });
// }
// $('.main-navigation.normal-menu .menu-main-menu-container li:has("ul")').on('keydown', function(e) {
// 	cKey = e.which;
//     cKeyShifted = e.shiftKey;
// });
$('.main-navigation.normal-menu .menu-main-menu-container li:has("ul")').on('mouseover keyup click mouseleave', function(e) {	
	var body = document.getElementsByTagName('body')[0];
	cKeyShifted = e.shiftKey;
  	var width = body.offsetWidth; 	
	  let menuAtag =$(this).find('> a');
	  if ( e.keyCode === 9 && !cKeyShifted ) {			  
		if (width < 960) {	
			menuAtag.attr("aria-expanded", true);	
			$(this).find('ul.sub-menu').addClass('open-submenu');
			
		}
		else {
			menuAtag.attr("aria-expanded", true);
			$(this).find('ul.sub-menu').addClass('keep-open');
			
		}	 
	}   	
});


$('.main-navigation.normal-menu .menu-main-menu-container li:has("ul")').focusout(function(e){
	
	setTimeout(function () {
		var focus = $(document.activeElement);
		if (focus.is(".sub-menu") || $(".sub-menu").has(focus).length) {			
		} else {	
				let submenu = $('.main-navigation.normal-menu .menu-main-menu-container li').find('.sub-menu');
				let parentsubmenu = submenu.parent();
				let menuAtag =parentsubmenu.find('> a');
				menuAtag.attr("aria-expanded", false);					
				submenu.removeClass('keep-open');					
				closeAllSubmenu();	
		}
	}, 0);			
});


// $(document).on("focusout", ".sub-menu", function (e) {
// 	setTimeout(function () {
// 		var focus = $(document.activeElement);
// 		if (focus.is(".sub-menu") || $(".sub-menu").has(focus).length) {			
// 		} else {				
// 			let submenu = $('.main-navigation.normal-menu .menu-main-menu-container li').find('.sub-menu');
// 			let parentsubmenu = submenu.parent();
// 			let menuAtag =parentsubmenu.find('> a');
// 			submenu.removeClass('keep-open');
// 			menuAtag.attr("aria-expanded", false);			
// 		}
// 	}, 0);
// });

// $('.glide__slide').focus(function(){	
// 	$(this).parent().find('li.glide__slide--active').removeClass('glide__slide--active');
// 	$(this).addClass('glide__slide--active');	
// });

// $('.glide__arrow--left').focusout(function(){		
// 	 let carouslUl = $(this).parent().find('.glide__slides> li');	
// 	 carouslUl.addClass('glide__slide--active');
// 	// carouslUl.css("transform","translate3d(100px, 0px, 0px)");	 
// 	 carouslUl.focus();		
// });
// $('.glide__slides > li:first-child').on('keydown', function(e) {
// 	shiftcarousal = e.shiftKey;
// 	keycodecarousal= e.keyCode;
	
// });
// $('.glide__slides > li:first-child').focusout(function(e){			
// 	if (!shiftcarousal ) {	
// 		$(this).parent().parent().parent().find('.glide__arrow--left').focus();
// 	}
// });

// $('.glide__arrow--left').on('keydown', function(e) {
// 	shiftleftarrow = e.shiftKey;
// 	keycodeleftarrow= e.keyCode;
	
// });
// $('.glide__arrow--left').focusout(function(e){		
// 	if (shiftleftarrow ) {		
// 		$(this).parent().parent().find('ul.glide__slides > li:first-child').focus();
// 	}
// });

// $('.glide__slides > li').on('keypress click',function(e){
// 	console.log('tt');
// 	//$(this).parent().find('.glide__slide--active').focus();
// });
 
//$('button.glide__arrow.glide__arrow--right').click();

$('.glide__slides li').on('keydown',function(e){	
	var keyCode = e.keyCode || e.which; 
	var shiftCode = e.shiftKey;
	if (keyCode == 9) { 		
		if($(this).prev('li').length == 0 && shiftCode) {				
		}
		else{		  			
			e.preventDefault(); 	
			if(shiftCode)
			{				
				$(this).parent().parent().parent().find('button.glide__arrow.glide__arrow--left').click();	
				if($(this).prev('li').length) {
					if($(this).parent().find('li.glide__slide--active').prev('li').length)					
					{
						$(this).parent().find('li.glide__slide--active').prev('li').focus();
					}
					else{
						$(this).parent().find('li.glide__slide--active').focus();
					}					
				}						
			}
			else{					
				$(this).parent().parent().parent().find('button.glide__arrow.glide__arrow--right').click();	
				if($(this).next('li').length) {				
					$(this).parent().find('li.glide__slide--active').next('li').focus();
				}
				else{
					$(this).parent().parent().parent().find('button.glide__arrow.glide__arrow--left').focus();
				}
			}
		}			
  	} 
 });
//  $(document).on("focusout", ".glide__slides", function (e) {
// 	setTimeout(function () {
// 		var focus = $(document.activeElement);
// 		if (focus.is(".glide__slides") || $(".glide__slides").has(focus).length) {
// 			console.log('ed');			
// 		} else {	
// 			console.log('ff');
// 		}
// 	}, 0);		
	 
//  });
//  $('.glide__slides li:first-child, .glide__slides li:last-child').on('focus',function(e){
// 	$(this).parent().find('li.glide__slide--active').focus();
//  });
// $('button.glide__arrow.glide__arrow--left').on('keydown',function(e){	
// 	var keyCode = e.keyCode || e.which; 
// 	var shiftCode = e.shiftKey;	
// 	if(shiftCode){
// 		$(this).parent().parent().html();
// 		$(this).parent().parent().find('li.glide__slide--active').next('li').focus();
// 	}	
// });

$('.only-mobile-menu').on('keydown','.hamicon.is-active', function(e){
	var menukeyCode = e.keyCode || e.which; 
 	var menushiftCode = e.shiftKey;	 
	if(menushiftCode == true && menukeyCode == 9) {	
		e.preventDefault(); 		 	
		 $(this).parent().parent().parent().find('.menu-main-menu-container>ul>li:last-child a').focus();
	 }
});

//new carousal
var tiles = [];
var dialog, dialogOverlay, dialogCloseButton, dialogOkButton;
var triggeringElement;

window.addEventListener('DOMContentLoaded', function(e) {
  /**
    Initialize Slick Slider with recommended configuration options
  */
  $('.carousel').slick({
    slidesToShow: 3,	
    infinite: false,
    speed: 300,	 
    slidesToScroll: 1,
	peek: {
		before: 100,
		after: 50,
	},    
    prevArrow: '<button class="previous-button is-control">' +
               '  <span class="fas fa-angle-left" aria-hidden="true"></span>Prev' +
               '  <span class="sr-only"> slide</span></button>',
    nextArrow: '<button class="next-button is-control">' +
               ' Next <span class="fas fa-angle-right" aria-hidden="true"></span>' +
               '  <span class="sr-only"> slide</span>' +
               '</button>',
	arrowsPlacement: 'afterSlides',
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
//   shortString(".jobs_search select option");
setFocusToJobsheading();
});

function shortString(selector) {
	const elements = document.querySelectorAll(selector);
	const tail = '...';
	if (elements && elements.length) {
	  for (const element of elements) {
		let text = element.innerText;
		  if (text.length > 30) {
			element.innerText = `${text.substring(0, 30 - tail.length).trim()}${tail}`;
		  }
		
	  }
	}
  }
  function setFocusToJobsheading(){
	  let josbheading = document.getElementById("jobs-found");
	  if(josbheading && ifparamexistsinurl('keyword')){
		
		$("html, body").animate({ scrollTop: $('#jobs-found').offset().top-100 }, 1000);
		josbheading.focus();
	  }
    
}
function ifparamexistsinurl(str){
	var field = str;
	var url = window.location.href;
	if(url.indexOf('?' + field + '=') != -1)
		return true;
	else if(url.indexOf('&' + field + '=') != -1)
		return true;
	return false
}